import { useInteragencyConversationById } from '../../reduxDataStore/interagency/interagencyAPI';
import { useSelectedInteragencyChat } from '../../reduxDataStore/interagency/interagencySlice';
import ParticipantBadge from '../ParticipantBadge';
import styles from './InteragencyChat.module.css';
import SubscriptionToggle from './SubscriptionToggle/SubscriptionToggle';

const InteragencyChatHeader = () => {
  const selectedConversation = useSelectedInteragencyChat();
  const conversation = useInteragencyConversationById(selectedConversation);

  return (
    <div className={styles.headerContainer} data-name="interagency-chat-header">
      <div className={styles.titleRow}>
        <div className={styles.title}>
          <span className={styles.liveDot} />
          <span>Agency Chat</span>
        </div>
        <SubscriptionToggle />
      </div>
      <div className={styles.participantList}>
        {conversation?.extra_info.participants.map(participant => (
          <ParticipantBadge
            key={participant.account_id}
            name={participant.user?.name || participant.authority_display_name}
          />
        ))}
      </div>
    </div>
  );
};

export default InteragencyChatHeader;
